import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import ProductPage from "./components/ProductPage";
import PlayingPage from "./components/PlayingPage";
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/product" element={<ProductPage />} />
        <Route path="/playing" element={<PlayingPage />} />
      </Routes>
    </Router>
  );
}

export default App;